import { useLayoutEffect, useRef } from 'react';

export const useActionLockTimelineScroll = <T extends HTMLElement>(selectedId: number | null) => {
  const itemRefs = useRef<Record<number, T | null>>({});

  useLayoutEffect(() => {
    if (!selectedId) return;
    const element = itemRefs.current[selectedId];
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [selectedId]);

  return itemRefs;
};
